module.exports = __webpack_public_path__ + "static/media/icn-watchlist-default.e28bb213.svg";